//
// # Authors
//
// Categorical differences in the places schematics, symbols, and the like come from,
// which often require different handling.
//

// Local Imports
import { Ident } from "../ident";

export enum Author {
  // Built-in *by us*.
  BuiltIn = "BuiltIn",

  // Built-in by an external tool or library. These are the ones that tend to get weird.
  ExternalBuiltIn = "ExternalBuiltIn",

  // PDK defined thing, often in external code. Also gets plenty weird.
  Pdk = "Pdk",

  // Everything else has been defined by a user.
  User = "User",
}

// Infer authorship based on an `Ident`.
export function authorship(ident: Ident): Author {
  if (ident.kind !== "libcellview") {
    return Author.BuiltIn;
  }
  const { kind, ...libCellView } = ident;

  const knownExternalBuiltins = new Set([
    "analogLib",
    "basic",
    // ...
  ]);
  if (knownExternalBuiltins.has(libCellView.lib)) {
    return Author.ExternalBuiltIn;
  }
  const knownPdkLibraries = new Set([
    "intel22prim",
    "intel22custom",
    // ... whatever else we need
  ]);
  if (knownPdkLibraries.has(libCellView.lib)) {
    return Author.Pdk;
  }

  // Default: must be from somewhere else, AKA the user.
  return Author.User;
}
